import { AggregatedPortfolioSeries } from "./aggregated-portfolio-series.class";
import { BaseEntityDetails } from "./entity-details.class";
import { Portfolio } from "./portfolio.class";



export class PortfolioHierarchy extends Portfolio {
    portfolioSeries!: AggregatedPortfolioSeries[];

    // additional properties for display in investor dashboard
    portfolioBalanceSummary!: InvestorDashboardPortfolioSeriesBalanceSummary[];

    tvpiIcon!: string;
    tvpiTitle!: string;
    irrIcon!: string;
    irrTitle!: string;
    formattedTvpi!: string;
    formattedIrr!: string;
    priorPeriod!: boolean;
}


export class BalanceSummary{
    contributions!: number| null;
    distributions!: number| null;
    nav!: number| null;
}

export class UsdBalanceSummary extends BalanceSummary{
    contributionsUSD!: number| null;
    distributionsUSD!: number| null;
    nAVUSD!: number| null;

    // additional properties
    masterId!: number;
    reportingPeriod!: string;
}

export class InvestorDashboardPortfolioSeriesBalanceSummary extends UsdBalanceSummary{
    hasInvestmentCommitments!: boolean;

    // additional properties to identify portfolio series
    disNavSum!: number;
    month!: number;
    year!: number;
    quarter!: string;

    static fromUsdBalanceSummary(usdBalanceSummary: UsdBalanceSummary): InvestorDashboardPortfolioSeriesBalanceSummary {
        const investorDashboardPortfolioSeriesBalanceSummary = new InvestorDashboardPortfolioSeriesBalanceSummary();
        Object.assign(investorDashboardPortfolioSeriesBalanceSummary, usdBalanceSummary);
        return investorDashboardPortfolioSeriesBalanceSummary;
    }
}

// matches C# InvestorDetails poco
export class InvestorDetails extends BaseEntityDetails {
    asOfDate!: Date;
    currency!: string;
}

// matches C# InvestorDashboard poco
export class InvestorDashboard {
    summary!: InvestorDetails;
    portfolios!: PortfolioHierarchy[];
    portfolioBalanceSummaries!: Record<number, Record<string, UsdBalanceSummary>>;
    portfolioSeriesBalanceSummaries!: Record<number, Record<string, InvestorDashboardPortfolioSeriesBalanceSummary>>;
}
